export default __webpack_public_path__ + "a42e9268a93223e59a2ced6b56241beb.jpg";